import { useEffect, useRef, useState, useContext } from "react";
import axios from "axios";
import useSWR from "swr";
import { WalletContentsDataContext } from "../../../contexts/WalletContentsContext";
import { WOW } from "wowjs";
import { Container, Row, Col, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import placeholder from "../../../assets/images/customplaceholder.png";
import formatIPFS from "../../../helpers/formatIPFS";
import fetchLRToken from "src/apis/fetchLRToken";
import NameHandler from "./NameHandler";
import NameHistory from "./NameHistory";
import LiveName from "../../LiveName";
import useGetName from "../../../hooks/useGetName";
import {
  openseaLogo,
  looksrareLogo,
  x2y2Logo,
  gemLogo,
  twitter,
  uniswap,
  remove,
  add,
} from "src/assets/images";
import { Web3Context } from "src/contexts";
import { useLookupAddress } from "src/hooks";
import useGetOwner from "src/hooks/useGetOwner";
import usePollAsync from "src/hooks/usePollAsync";
import TwitterModal from "./TwitterModal";
import DisplayTooltip from "./DisplayTooltip";
import { removeTwitter, signMessage } from "src/helpers/social";
import { fetchAlchemyToken, fetchOSToken } from "src/apis";
import { looksrarePrices, openseaPrices } from "src/apis/getTokenPrices";

const defaultLRData = {
  imageURI: "",
  name: "",
  collectionName: "",
  attributes: [],
};

const baseURL = process.env.REACT_APP_API_URL_BASE;

const RobotDetails = ({ contractAddress, tokenId }) => {
  const [nameUpdated, setNameUpdated] = useState(false);
  const { data: walletContents } = useContext(WalletContentsDataContext);
  const { injectedProvider, address, userSigner } = useContext(Web3Context);
  const [tokenPrices, setTokenPrices] = useState({
    opensea: null,
    looksrare: null,
    x2y2: null,
  });

  const { owner } = useGetOwner(contractAddress, tokenId);
  const ens = useLookupAddress(injectedProvider, owner);

  let displayAddress = owner.substring(0, 6);

  if (ens && ens.indexOf("0x") < 0) {
    displayAddress = ens;
  }
  const renderRef = useRef(0);

  const contractAddressToUse = contractAddress.toLowerCase();
  const tokenIdToUse = tokenId;

  const fetcher = (url) => fetch(url).then((res) => res.json());

  const { data: userSocial, error: userSocialError } = useSWR(
    contractAddressToUse && tokenIdToUse && address
      ? `${baseURL}user/social?userAddress=${address}&contractAddress=${contractAddressToUse}&tokenId=${tokenIdToUse}`
      : null,
    fetcher
  );

  const [LRData, setLRData] = useState(defaultLRData);
  const [tweetId, setTweetId] = useState(null);
  let owned = false;
  let robotFromStorage;
  let robot = robotFromStorage;
  let collectionName = LRData?.collectionName;

  const { name, updateName } = useGetName(contractAddress, tokenIdToUse, 5000);

  const { data: namingTweet, error: namingTweetError } = useSWR(
    contractAddressToUse && tokenIdToUse && name
      ? `${baseURL}twitter/tweet?name=${name}&contractAddress=${contractAddressToUse}&tokenId=${tokenIdToUse}`
      : null,
    fetcher
  );
  const twitterConnectionUrl = `${baseURL}auth/twitter?userAddress=${address}&contractAddress=${contractAddressToUse}&tokenId=${tokenIdToUse}`;

  useEffect(() => {
    if (userSocial && !userSocial.twitterVerified) {
      signMessage(userSigner, userSocial)
        .then((signature) => {
          axios.post(`${baseURL}twitter/verify`, {
            twitterUsername: userSocial.twitterUsername,
            signature,
          });
        })
        .catch(async (error) => {
          console.log("rejected", error);
          await axios.post(`${baseURL}twitter/remove`, {
            contractAddress: contractAddressToUse,
            tokenId: tokenIdToUse,
            twitterUsername: userSocial.twitterUsername,
          });
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSocial]);

  const connectTwitter = () => {
    if (address) window.location.href = twitterConnectionUrl;
  };

  useEffect(() => {
    fetchLRToken(contractAddressToUse, tokenIdToUse)
      .then(({ data }) => {
        if (data)
          setLRData({
            imageURI: data.imageURI,
            name: data.name,
            collectionName: data.collection.name,
            attributes: data.attributes,
          });
      })
      .catch((error) => {
        console.log(error);
      });

    async function getPrices() {
      const { data } = await axios.post(`${baseURL}token-events`, {
        contractAddress: contractAddressToUse,
        tokenId: tokenIdToUse,
      });

      const { openseaPrice, looksrarePrice, x2y2Price } = data;
      console.log({ openseaPrice, looksrarePrice, x2y2Price });
      setTokenPrices((prev) => ({
        ...prev,
        opensea: openseaPrice,
        looksrare: looksrarePrice,
        x2y2: x2y2Price,
      }));
    }

    getPrices();
  }, [contractAddressToUse, tokenIdToUse]);

  useEffect(() => {
    new WOW({
      mobile: false,
      live: false,
    }).init();
  }, []);

  if (
    walletContents?.nfts?.length &&
    walletContents.nfts.find(
      (e) =>
        e.contractAddress.toLowerCase() ===
          contractAddressToUse.toLowerCase() &&
        Number(e.tokenId) === Number(tokenIdToUse)
    )
  ) {
    owned = true;
  }

  let url = LRData.imageURI || robot?.imageUrl || robot?.image;

  const findNamingTweet = async () => {
    try {
      const { data } = await axios.post(`${baseURL}twitter/search/tweet`, {
        collectionName,
        tokenId: tokenIdToUse,
        contractAddress: contractAddressToUse,
        name: name,
      });
      const { tweetId } = data;
      if (tweetId) {
        setTweetId(tweetId);
        setNameUpdated(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  let enabled = false;

  if (owned && name && contractAddressToUse && tokenIdToUse && nameUpdated) {
    enabled = true;
  }

  if (tweetId || nameUpdated === false) {
    enabled = false;
  }

  // eslint-disable-next-line no-unused-vars
  const update = usePollAsync(findNamingTweet, 10000, enabled);
  if (url && url.toLowerCase().indexOf("ipfs")) url = formatIPFS(url);

  if (!url) {
    url = placeholder;
  }

  if (url && url.length && url.indexOf("lh3") > -1) {
    url = url + "=w600";
  }

  async function handleRemoveTwitter() {
    try {
      const signature = await signMessage(userSigner, userSocial, true);

      if (signature) {
        await removeTwitter(
          contractAddressToUse,
          tokenIdToUse,
          userSocial.twitterUsername
        );
      }
    } catch (error) {}
  }

  const prices = [
    tokenPrices.opensea,
    tokenPrices.looksrare,
    tokenPrices.x2y2,
  ].filter((item) => item !== null);

  // log;
  const minPrice = Math.min(...prices);

  return (
    <section className="robot-details">
      <div className="robot-details-shape position-relative">
        <Image
          className="position-absolute robot-details-shape"
          src="./img/robot-details-shape.png"
        />
      </div>
      <Container>
        <Row className="justify-content-center">
          <Col lg={12}>
            <div className="robot-details-content wow fadeIn">
              <Row className="robot-details-buttons justify-content-between align-items-baseline mx-0">
                <div style={{ width: "auto", padding: "0" }}>
                  <Link className="navigation" to="/lets-browse">
                    <i className="fas fa-angle-left"></i> Back
                  </Link>
                </div>
                <div style={{ width: "auto", margin: "0", padding: "0" }}>
                  <p className="text-pink p-0 mb-0 fs-4 d-flex">
                    owned by{" "}
                    {owned ? (
                      <span>&nbsp;you</span>
                    ) : displayAddress.length < 15 ? (
                      <a
                        className="text-pink ms-1"
                        target="_blank"
                        href={`https://etherscan.io/address/${owner}`}
                        rel="noreferrer"
                      >
                        {displayAddress}
                      </a>
                    ) : (
                      <DisplayTooltip
                        owner={owner}
                        displayAddress={displayAddress}
                      />
                    )}
                  </p>
                </div>
              </Row>

              <Row className="align-items-start">
                <Col lg={5}>
                  <div className="robot-details-wrapper">
                    <div className="robot-details-thumbnail">
                      <Image
                        className="punk"
                        src={url}
                        onError={async function (error) {
                          renderRef.current++;
                          setTimeout(async () => {
                            if (renderRef.current === 1) {
                              error.target.src = await fetchOSToken(
                                contractAddress,
                                tokenId
                              );
                            } else if (renderRef.current === 2) {
                              error.target.src = await fetchAlchemyToken(
                                contractAddress,
                                tokenId
                              );
                            } else if (renderRef.current === 3) {
                              error.target.src = placeholder;
                            }
                          }, 50);
                        }}
                      />
                    </div>
                    <div style={{ textAlign: "start" }}>
                      <h3>
                        <LiveName
                          updateInterval={5000}
                          contractAddress={contractAddress}
                          tokenId={tokenIdToUse}
                        />
                      </h3>
                      {collectionName ? (
                        <h3
                          className="text-pink robot-details-collection-name"
                          style={{ fontWeight: "lighter" }}
                        >
                          {" "}
                          {contractAddress ? (
                            <a
                              href={
                                "https://etherscan.io/address/" +
                                contractAddress
                              }
                              rel="noreferrer"
                              target="_blank"
                              style={{
                                textDecoration: "inherit",
                                color: "inherit",
                              }}
                            >
                              {collectionName}
                            </a>
                          ) : (
                            collectionName
                          )}
                        </h3>
                      ) : null}
                      <h4 className="text-green robot-details-token-id">
                        {" "}
                        {contractAddress && tokenIdToUse ? (
                          <a
                            href={
                              "https://etherscan.io/token/" +
                              contractAddress +
                              "?a=" +
                              tokenIdToUse
                            }
                            rel="noreferrer"
                            target="_blank"
                            style={{
                              textDecoration: "inherit",
                              color: "inherit",
                            }}
                          >
                            ID {tokenIdToUse}
                          </a>
                        ) : (
                          "ID " + tokenIdToUse
                        )}
                      </h4>

                      {contractAddress && tokenIdToUse ? (
                        <Row className="marketplace">
                          <Col>
                            <Tooltip
                              content={
                                tokenPrices.opensea === null
                                  ? null
                                  : +tokenPrices.opensea === minPrice
                                  ? `Best price: ${tokenPrices.opensea} Ξ`
                                  : `${tokenPrices.opensea} Ξ`
                              }
                              direction="bottom"
                              id="opensea-tooltip"
                              style={
                                tokenPrices.opensea === null
                                  ? null
                                  : +tokenPrices.opensea === minPrice
                                  ? { border: "2px solid #00F5B2" }
                                  : tokenPrices.opensea
                                  ? { border: "2px solid #fc4ba3" }
                                  : null
                              }
                            >
                              <a
                                href={`https://opensea.io/assets/ethereum/${contractAddress}/${tokenId}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <img
                                  className="marketplace-logo"
                                  src={openseaLogo}
                                  alt="Opensea logo"
                                />
                              </a>
                            </Tooltip>
                          </Col>
                          <Col>
                            <Tooltip
                              content={
                                tokenPrices.looksrare === null
                                  ? null
                                  : +tokenPrices.looksrare === minPrice
                                  ? `Best price: ${tokenPrices.looksrare} Ξ`
                                  : `${tokenPrices.looksrare} Ξ`
                              }
                              direction="bottom"
                              style={
                                tokenPrices.looksrare === null
                                  ? null
                                  : +tokenPrices.looksrare === minPrice
                                  ? { border: "2px solid #00F5B2" }
                                  : tokenPrices.looksrare
                                  ? { border: "2px solid #fc4ba3" }
                                  : null
                              }
                            >
                              <a
                                href={`https://looksrare.org/collections/${contractAddress}/${tokenId}`}
                                target="_blank"
                                rel="noreferrer"
                                className="marketplace-link"
                              >
                                <img
                                  className="marketplace-logo"
                                  src={looksrareLogo}
                                  alt="Looksrare logo"
                                />
                              </a>
                            </Tooltip>
                          </Col>
                          <Col>
                            <Tooltip
                              direction="bottom"
                              content={
                                tokenPrices.x2y2 === null
                                  ? null
                                  : +tokenPrices.x2y2 === minPrice
                                  ? `Best price: ${tokenPrices.x2y2} Ξ`
                                  : `${tokenPrices.x2y2} Ξ`
                              }
                              style={
                                tokenPrices.x2y2 === null
                                  ? null
                                  : +tokenPrices.x2y2 === minPrice
                                  ? { border: "2px solid #00F5B2" }
                                  : tokenPrices.x2y2
                                  ? { border: "2px solid #fc4ba3" }
                                  : null
                              }
                            >
                              <a
                                href={`https://x2y2.io/eth/${contractAddress}/${tokenId}`}
                                target="_blank"
                                rel="noreferrer"
                                className="marketplace-link"
                              >
                                <img
                                  className="marketplace-logo"
                                  src={x2y2Logo}
                                  alt="x2y2 logo"
                                />
                              </a>
                            </Tooltip>
                          </Col>
                          <Col>
                            <Tooltip direction="bottom">
                              <a
                                href={`https://www.gem.xyz/asset/${contractAddress}/${tokenId}`}
                                target="_blank"
                                rel="noreferrer"
                                className="marketplace-link"
                              >
                                <img
                                  className="marketplace-logo"
                                  src={gemLogo}
                                  alt="gem logo"
                                />
                              </a>
                            </Tooltip>
                          </Col>
                          <Col>
                            <Tooltip direction="bottom">
                              <a
                                href={`https://app.uniswap.org/#/nfts/asset/${contractAddress}/${tokenId}`}
                                target="_blank"
                                rel="noreferrer"
                                className="marketplace-link"
                              >
                                <img
                                  className="marketplace-logo"
                                  src={uniswap}
                                  alt="uniswap marketplace logo"
                                />
                              </a>
                            </Tooltip>
                          </Col>
                        </Row>
                      ) : (
                        <Row>
                          <div>Opensea</div>
                          <div>Looksrare</div>
                          <a
                            className="text-green"
                            href="https://google.com"
                            target="_blank"
                            rel="noreferrer"
                          >
                            View on Opensea
                          </a>
                        </Row>
                      )}
                    </div>
                  </div>
                  <div className="mt-4">
                    <div className="flex justify-content-center align-items-center">
                      {(userSocial && userSocial.twitterUsername) || owned ? (
                        <Tooltip
                          content="Bind your twitter account"
                          direction="bottom"
                        >
                          <img
                            style={{
                              width: "25px",
                              marginRight: "16px",
                              marginTop: "-10px",
                            }}
                            src={twitter}
                            alt="Twitter Logo"
                          />
                        </Tooltip>
                      ) : null}
                      {userSocial && userSocial.twitterVerified ? (
                        <a
                          href={`https://twitter.com/${userSocial.twitterUsername}`}
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            textDecoration: "none",
                          }}
                          className="text-white fs-4"
                        >
                          @{userSocial.twitterUsername}
                        </a>
                      ) : null}

                      {owned && !userSocial ? (
                        <span onClick={connectTwitter}>
                          <img
                            style={{
                              width: "25px",
                              marginRight: "16px",
                              cursor: "pointer",
                              marginTop: "-10px",
                            }}
                            src={add}
                            alt="Twitter Logo"
                          />
                        </span>
                      ) : null}
                      {owned && userSocial ? (
                        <span
                          onClick={handleRemoveTwitter}
                          style={{
                            cursor: "pointer",
                            marginLeft: "24px",
                          }}
                        >
                          <img
                            style={{ width: "25px", marginTop: "-10px" }}
                            src={remove}
                            alt="remove twitter "
                          />
                        </span>
                      ) : null}
                    </div>
                  </div>
                </Col>
                <Col lg={7}>
                  <NameHandler
                    owned={owned}
                    contractAddress={contractAddress}
                    tokenId={tokenIdToUse}
                    providedName={name}
                    updateName={updateName}
                    setNameUpdated={setNameUpdated}
                  />

                  <NameHistory
                    contractAddress={contractAddress}
                    tokenId={tokenIdToUse}
                    providedName={name}
                    namingTweet={namingTweet}
                  />
                  {/* <RNMHandler owned={owned} /> */}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>

        {tweetId && !namingTweet?.length ? (
          <div>
            <TwitterModal tweetId={tweetId}></TwitterModal>
          </div>
        ) : null}
      </Container>
    </section>
  );
};

export default RobotDetails;

const Tooltip = (props) => {
  let timeout;
  const [active, setActive] = useState(false);

  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, props.delay || 400);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  return (
    <div
      className="Tooltip-Wrapper"
      id={props.id}
      // When to show the tooltip
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
      style={props.style}
    >
      {/* Wrapping */}
      {props.children}
      {active && (
        <div className={`Tooltip-Tip ${props.direction || "top"}`}>
          {/* Content */}
          {props.content}
        </div>
      )}
    </div>
  );
};
